/** Illustrative policy rows shared by the Knowledge Curation workspace and connections preview. */

export type ReviewStatus = "overdue" | "conflict" | "current";

export const SAMPLE_POLICIES: {
  name: string;
  description: string;
  audience: "Private" | "Public";
  due: string;
  displayDue: string;
  status: ReviewStatus;
}[] = [
  {
    name: "Access review policy",
    description: "Review of employee access",
    audience: "Private",
    due: "2026-08-15",
    displayDue: "15 Aug 2026",
    status: "overdue",
  },
  {
    name: "Support transcript policy",
    description: "Support transcripts · retain for 90 days",
    audience: "Private",
    due: "2026-12-01",
    displayDue: "1 Dec 2026",
    status: "conflict",
  },
  {
    name: "Contact-center retention policy",
    description: "Support transcripts · retain for 365 days",
    audience: "Private",
    due: "2026-12-01",
    displayDue: "1 Dec 2026",
    status: "conflict",
  },
  {
    name: "Customer support guide",
    description: "Approved customer-facing guidance",
    audience: "Public",
    due: "2026-10-01",
    displayDue: "1 Oct 2026",
    status: "current",
  },
];

export const STATUS_LABEL: Record<ReviewStatus, string> = {
  overdue: "Overdue",
  conflict: "Conflict",
  current: "Current",
};
